import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,Typography } from "@mui/material";
import styles from "./style";
import CustomPagination from "../../../../../components/CustomPagination";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import{ ProfitData }from "../../../../../constants/data"
// import { useAlert } from "../../../../context/AlertContext";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import {ReactComponent as Edit}from "../../../../../assets/images/edit.svg";

const SalesList = () => {

  
  const [page, setPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // const {showAlert} =useAlert();
  
  return (
    <>

           
      <TableContainer  sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>Sales Order</TableCell>
              <TableCell sx={styles.tableHead}>Opportunity Name</TableCell>
              <TableCell sx={styles.tableHead}>Sub Total</TableCell>
              <TableCell sx={styles.tableHead}>Tax</TableCell>
              <TableCell sx={styles.tableHead}>Action</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {ProfitData?.length === 0 ? ( 
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              ProfitData?.map((item, index) => (
                <TableRow key={index} sx={{verticalAlign:"baseline"}}>
                  <TableCell sx={styles.tabledata}>{item?.type} </TableCell>
                  <TableCell sx={styles.tabledata}>{item?.total}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.amount}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.var}</TableCell>
                  <TableCell sx={styles.tabledata}><Edit /><MoreVertIcon sx={styles.vertIcon}/></TableCell>

                </TableRow>
              ))
            )}
          </TableBody>

        </Table>
        {ProfitData &&
       <CustomPagination
         //  pageCount={totalCount}         
         page={page}
         setPage={setPage}
         rowsPerPage={rowsPerPage}
         setRowsPerPage={setRowsPerPage}
         totalItems={ProfitData.length}
       />} 

      </TableContainer>


    </>
  );
};
export default SalesList;
